import { render } from "./FormTitle.vue?vue&type=template&id=7d65157d&scoped=true"
import script from "./FormTitle.vue?vue&type=script&lang=js"
export * from "./FormTitle.vue?vue&type=script&lang=js"

import "./FormTitle.vue?vue&type=style&index=0&id=7d65157d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d65157d"]])

export default __exports__